<div class="dropzone-custom">
    <div
        class="dropzone dropzone-primary"
        [dropzone]="config"
        (success)="onUploadInfo($event)">

        <div class="dz-message needsclick compact-dropzone">           
            <nb-icon
                icon="file-add-outline" 
                style="font-size:28px;color:#00d68f;">
            </nb-icon>
            <small>Agregar archivo o imagen</small>
        </div>
    </div>
</div>

<div class="image-list" *ngIf="images.length">
    <div class="image-item" *ngFor="let file of images; let i=index">
        
        <img 
            *ngIf="file.includes('.jpg') || file.includes('.png') || file.includes('.jpeg') || file.includes('image'); else noImage"
            [src]="file"
            (click)="preview(file)">
        
        <ng-template #noImage>
            <div class="file-preview" style="padding: 10px; text-align: center;">
                <nb-icon icon="file-text-outline" style="font-size: 40px;"></nb-icon>
                <a [href]="file" target="_blank" style="display: block; font-size: 12px; max-width: 100px; overflow: hidden; text-overflow: ellipsis;">
                    Ver archivo
                </a>
            </div>
        </ng-template>

        <button
            nbButton
            size="tiny"
            status="danger"
            (click)="removeImage(i)">
            <nb-icon icon="trash-outline"></nb-icon>
        </button>
    </div>
</div>